// ============================================================================
// PLAYER AGES — Birth years for all current NBA players
// Source: balldontlie API + reference data
// At runtime, fetchAndCacheAges() refreshes from API
// ============================================================================

// Static birth years — comprehensive for 2025-26 rosters
// Format: 'Player Name': birthYear
const PLAYER_BIRTH_YEARS = {
  // ATL
  'CJ McCollum': 1991, 'Jalen Johnson': 2002, 'Jonathan Kuminga': 2002,
  'Nickeil Alexander-Walker': 1998, 'Onyeka Okongwu': 2000, 'Corey Kispert': 1999,
  'Zaccharie Risacher': 2005, 'Gabe Vincent': 1996, 'Buddy Hield': 1992,
  'Dyson Daniels': 2003, 'Asa Newell': 2006, 'Jock Landale': 1995,
  'Duop Reath': 1997, 'Mouhamed Gueye': 2003, "N'Faly Dante": 2002,
  'Nikola Djurisic': 2003, 'Caleb Houstan': 2003, 'Jacob Toppin': 1999,
  'David Roddy': 2000, 'Christian Koloko': 2000,
  // BKN
  'Michael Porter': 1998, 'Nicolas Claxton': 1999, 'Terance Mann': 1996,
  'Egor Demin': 2006, 'Ochai Agbaji': 1999, "Day'Ron Sharpe": 2001,
  'Ziaire Williams': 2001, 'Cam Thomas': 2001, 'Kobe Bufkin': 2003,
  'Nolan Traore': 2006, 'Noah Clowney': 2004, 'Dariq Whitehead': 2003,
  'Danny Wolf': 2002, 'Ben Saraf': 2006, 'Drake Powell': 2005,
  'Josh Minott': 2002, 'Jalen Wilson': 2000, 'Hunter Tyson': 1999,
  // BOS
  'Jayson Tatum': 1998, 'Jaylen Brown': 1996, 'Derrick White': 1994,
  'Nikola Vucevic': 1990, 'Sam Hauser': 1997, 'Payton Pritchard': 1998,
  'Baylor Scheierman': 2000, 'Luka Garza': 1998, 'Neemias Queta': 1999,
  'Jordan Walsh': 2004, 'Hugo Gonzalez': 2004,
  // CHA
  'LaMelo Ball': 2001, 'Miles Bridges': 1998, 'Josh Green': 2000,
  'Grant Williams': 1998, 'Coby White': 2000, 'Brandon Miller': 2003,
  'Mike Conley': 1987, 'Kon Knueppel': 2004, 'Tre Mann': 2001,
  'Tidjane Salaun': 2005, 'Malaki Branham': 2003, 'Mark Williams': 2001,
  'Pat Connaughton': 1993,
  // CHI
  'Zach LaVine': 1995, 'Nikola Vucevic': 1990, 'Lonzo Ball': 1997,
  'Ayo Dosunmu': 1999, 'Patrick Williams': 2001, 'Josh Giddey': 2002,
  'Talen Horton-Tucker': 2000, 'Jalen Smith': 2000, 'Matas Buzelis': 2005,
  'Julian Phillips': 2003, 'Dalen Terry': 2002, 'Jevon Carter': 1995,
  'Torrey Craig': 1990,
  // CLE
  'Donovan Mitchell': 1996, 'Darius Garland': 2000, 'Evan Mobley': 2001,
  'Jarrett Allen': 1998, 'Max Strus': 1996, 'Caris LeVert': 1994,
  'Isaac Okoro': 2001, 'Georges Niang': 1993, 'Sam Merrill': 1996,
  'Craig Porter Jr.': 2000, 'Ty Jerome': 1997, 'Dean Wade': 1997,
  'Jaylon Tyson': 2002, 'Luke Travers': 2002,
  // DAL
  'Luka Doncic': 1999, 'Kyrie Irving': 1992, 'Klay Thompson': 1990,
  'PJ Washington': 1998, 'Daniel Gafford': 1998, 'Naji Marshall': 1998,
  'Quentin Grimes': 1999, 'Dwight Powell': 1991, 'Jaden Hardy': 2002,
  'Dereck Lively II': 2004, 'Brandon Williams': 2000, 'A.J. Lawson': 2000,
  'Olivier-Maxence Prosper': 2002, 'Spencer Dinwiddie': 1993,
  // DEN
  'Nikola Jokic': 1995, 'Jamal Murray': 1997, 'Michael Porter Jr.': 1998,
  'Aaron Gordon': 1995, 'Christian Braun': 2001, 'Russell Westbrook': 1988,
  'Dario Saric': 1994, 'Julian Strawther': 2002, 'Peyton Watson': 2003,
  'Zeke Nnaji': 2001, 'Hunter Tyson': 1999, 'DeAndre Jordan': 1988,
  'DaRon Holmes II': 2003, 'Jalen Pickett': 1999, 'Trey Alexander': 2003,
  // DET
  'Cade Cunningham': 2001, 'Jaden Ivey': 2002, 'Ausar Thompson': 2003,
  'Tobias Harris': 1992, 'Isaiah Stewart': 2001, 'Tim Hardaway Jr.': 1992,
  'Malik Beasley': 1996, 'Jalen Duren': 2003, 'Simone Fontecchio': 1995,
  'Ron Holland II': 2005, 'Marcus Sasser': 2000, 'Wendell Moore Jr.': 2001,
  'Bobi Klintman': 2003, 'Ausar Thompson': 2003,
  // GSW
  'Stephen Curry': 1988, 'Andrew Wiggins': 1995, 'Draymond Green': 1990,
  'Jonathan Kuminga': 2002, 'Kevon Looney': 1996, 'Brandin Podziemski': 2003,
  'Kyle Anderson': 1993, 'Buddy Hield': 1992, 'Gary Payton II': 1992,
  'Trayce Jackson-Davis': 2000, 'De\'Anthony Melton': 1998, 'Moses Moody': 2002,
  'Lindy Waters III': 1997, 'Quinten Post': 2000,
  // HOU
  'Jalen Green': 2002, 'Fred VanVleet': 1994, 'Alperen Sengun': 2002,
  'Jabari Smith Jr.': 2003, 'Dillon Brooks': 1996, 'Tari Eason': 2001,
  'Amen Thompson': 2003, 'Reed Sheppard': 2004, 'Jeff Green': 1986,
  'Steven Adams': 1993, 'Cam Whitmore': 2003, 'Jack McVeigh': 2000,
  // IND
  'Tyrese Haliburton': 2000, 'Pascal Siakam': 1994, 'Myles Turner': 1996,
  'Andrew Nembhard': 2000, 'Bennedict Mathurin': 2002, 'Aaron Nesmith': 2000,
  'T.J. McConnell': 1992, 'Obi Toppin': 1997, 'James Wiseman': 2001,
  'Ben Sheppard': 2001, 'Isaiah Jackson': 2001, 'Jarace Walker': 2003,
  'Tristen Newton': 2001,
  // LAC
  'James Harden': 1989, 'Norman Powell': 1993, 'Ivica Zubac': 1997,
  'Terance Mann': 1996, 'Derrick Jones Jr.': 1997, 'Bones Hyland': 2001,
  'Kris Dunn': 1994, 'Amir Coffey': 1997, 'Jordan Miller': 2000,
  'Kai Jones': 2001, 'Nicolas Batum': 1988,
  // LAL
  'LeBron James': 1984, 'Anthony Davis': 1993, 'Austin Reaves': 1998,
  'D\'Angelo Russell': 1996, 'Rui Hachimura': 1998, 'Dalton Knecht': 2001,
  'Jarred Vanderbilt': 1999, 'Gabe Vincent': 1996, 'Max Christie': 2003,
  'Jaxson Hayes': 1999, 'Christian Wood': 1995, 'Bronny James': 2004,
  'Dorian Finney-Smith': 1993,
  // MEM
  'Ja Morant': 1999, 'Desmond Bane': 1998, 'Jaren Jackson Jr.': 1999,
  'Marcus Smart': 1994, 'Santi Aldama': 2000, 'Brandon Clarke': 1996,
  'Luke Kennard': 1996, 'GG Jackson II': 2004, 'Jake LaRavia': 2001,
  'Vince Williams Jr.': 2000, 'Zach Edey': 2002, 'Jay Huff': 1998,
  'Scotty Pippen Jr.': 2000, 'John Konchar': 1996,
  // MIA
  'Jimmy Butler': 1989, 'Bam Adebayo': 1997, 'Tyler Herro': 2000,
  'Terry Rozier': 1994, 'Duncan Robinson': 1994, 'Jaime Jaquez Jr.': 2001,
  'Nikola Jovic': 2003, 'Haywood Highsmith': 1996, 'Kevin Love': 1988,
  'Thomas Bryant': 1997, 'Josh Richardson': 1993, 'Pelle Larsson': 2001,
  'Kel\'el Ware': 2004,
  // MIL
  'Giannis Antetokounmpo': 1994, 'Damian Lillard': 1990, 'Khris Middleton': 1991,
  'Brook Lopez': 1988, 'Bobby Portis': 1995, 'Pat Connaughton': 1993,
  'Gary Trent Jr.': 1999, 'AJ Green': 2000, 'Andre Jackson Jr.': 2001,
  'MarJon Beauchamp': 2001, 'Ryan Rollins': 2002, 'Tyler Smith': 2004,
  // MIN
  'Anthony Edwards': 2001, 'Julius Randle': 1994, 'Rudy Gobert': 1992,
  'Jaden McDaniels': 2000, 'Mike Conley': 1987, 'Naz Reid': 1999,
  'Nickeil Alexander-Walker': 1998, 'Donte DiVincenzo': 1997,
  'Joe Ingles': 1987, 'Luka Garza': 1998, 'Rob Dillingham': 2004,
  'Leonard Miller': 2003, 'Josh Minott': 2002,
  // NOP
  'Zion Williamson': 2000, 'Brandon Ingram': 1997, 'CJ McCollum': 1991,
  'Trey Murphy III': 2000, 'Herbert Jones': 1998, 'Jose Alvarado': 1998,
  'Dejounte Murray': 1996, 'Jordan Hawkins': 2002, 'Yves Missi': 2004,
  'Jeremiah Robinson-Earl': 2000, 'Daniel Theis': 1992, 'Javonte Green': 1993,
  // NYK
  'Jalen Brunson': 1996, 'Karl-Anthony Towns': 1995, 'OG Anunoby': 1997,
  'Mikal Bridges': 1996, 'Josh Hart': 1995, 'Miles McBride': 2001,
  'Mitchell Robinson': 1998, 'Cameron Payne': 1994, 'Tyler Kolek': 2001,
  'Jericho Sims': 1998, 'Ariel Hukporti': 2002, 'Pacome Dadiet': 2005,
  // OKC
  'Shai Gilgeous-Alexander': 1998, 'Jalen Williams': 2001, 'Chet Holmgren': 2002,
  'Lu Dort': 1999, 'Isaiah Hartenstein': 1998, 'Alex Caruso': 1994,
  'Kenrich Williams': 1994, 'Aaron Wiggins': 1999, 'Isaiah Joe': 1999,
  'Dillon Jones': 2003, 'Ajay Mitchell': 2002, 'Nikola Topic': 2005,
  'Ousmane Dieng': 2003, 'Jaylin Williams': 2002,
  // ORL
  'Paolo Banchero': 2002, 'Franz Wagner': 2001, 'Jalen Suggs': 2001,
  'Wendell Carter Jr.': 1999, 'Anthony Black': 2004, 'Gary Harris': 1994,
  'Cole Anthony': 2000, 'Goga Bitadze': 1999, 'Tristan da Silva': 2001,
  'Jett Howard': 2003, 'Jonathan Isaac': 1997, 'Caleb Houstan': 2003,
  'Kentavious Caldwell-Pope': 1993,
  // PHI
  'Joel Embiid': 1994, 'Tyrese Maxey': 2000, 'Paul George': 1990,
  'Caleb Martin': 1995, 'Andre Drummond': 1993, 'Kelly Oubre Jr.': 1995,
  'Kyle Lowry': 1986, 'Eric Gordon': 1988, 'Guerschon Yabusele': 1995,
  'KJ Martin': 2001, 'Jared McCain': 2004, 'Adem Bona': 2003,
  'Jeff Dowtin Jr.': 1997, 'Ricky Council IV': 2001,
  // PHX
  'Kevin Durant': 1988, 'Devin Booker': 1996, 'Bradley Beal': 1993,
  'Jusuf Nurkic': 1994, 'Grayson Allen': 1995, 'Royce O\'Neale': 1993,
  'Mason Plumlee': 1989, 'Josh Okogie': 1998, 'Ryan Dunn': 2002,
  'Bol Bol': 1999, 'Collin Gillespie': 1999, 'Monte Morris': 1995,
  'TyTy Washington Jr.': 2002,
  // POR
  'Anfernee Simons': 1999, 'Jerami Grant': 1994, 'Deandre Ayton': 1998,
  'Shaedon Sharpe': 2003, 'Deni Avdija': 2001, 'Robert Williams III': 1997,
  'Toumani Camara': 2000, 'Scoot Henderson': 2004, 'Dalano Banton': 1999,
  'Donovan Clingan': 2004, 'Duop Reath': 1997, 'Matisse Thybulle': 1997,
  // SAC
  "De'Aaron Fox": 1997, 'Domantas Sabonis': 1996, 'Keegan Murray': 2000,
  'DeMar DeRozan': 1989, "Malik Monk": 1998, 'Kevin Huerter': 1998,
  'Trey Lyles': 1995, 'Alex Len': 1993, 'Keon Ellis': 2000,
  'Colby Jones': 2001, 'Devin Carter': 2002,
  // SAS
  'Victor Wembanyama': 2004, 'Devin Vassell': 2000, 'Jeremy Sochan': 2003,
  'Keldon Johnson': 2000, 'Tre Jones': 2000, 'Zach Collins': 1997,
  'Julian Champagnie': 2000, 'Malaki Branham': 2003, 'Blake Wesley': 2002,
  'Stephon Castle': 2005, 'Harrison Barnes': 1992,
  // TOR
  'Scottie Barnes': 2001, 'RJ Barrett': 2000, 'Immanuel Quickley': 1999,
  'Jakob Poeltl': 1995, 'Gradey Dick': 2003, 'Ochai Agbaji': 1999,
  'Bruce Brown': 1996, 'Kelly Olynyk': 1991, 'Chris Boucher': 1993,
  'Davion Mitchell': 1998, 'Ja\'Kobe Walter': 2004, 'Garrett Temple': 1986,
  // UTA
  'Lauri Markkanen': 1997, 'Jordan Clarkson': 1992, 'Collin Sexton': 1999,
  'John Collins': 1997, 'Walker Kessler': 2001, 'Keyonte George': 2003,
  'Taylor Hendricks': 2003, 'Brice Sensabaugh': 2003, 'Kyle Filipowski': 2002,
  'Cody Williams': 2005, 'Isaiah Collier': 2004, 'Patty Mills': 1988,
  // WAS
  'Jordan Poole': 1999, 'Kyle Kuzma': 1995, 'Jonas Valanciunas': 1992,
  'Bilal Coulibaly': 2004, 'Malcolm Brogdon': 1992, 'Corey Kispert': 1999,
  'Alex Sarr': 2005, 'Kyshawn George': 2004, 'Bub Carrington': 2005,
  'Carlton Carrington': 2005, 'Marvin Bagley III': 1999, 'Saddiq Bey': 1999,
  'Johnny Davis': 2002,
  // Additional notable players (may have moved teams)
  'Kawhi Leonard': 1991, 'Kristaps Porzingis': 1995, 'Chris Paul': 1985,
  'Al Horford': 1986, 'Trae Young': 1998, 'Brandon Ingram': 1997,
  'Lonzo Ball': 1997, 'Zach LaVine': 1995,
};

// Runtime cache — populated from API or static data
let _ageCache = {};
let _cacheReady = false;

/**
 * Get a player's age for the given season year.
 * Uses cached birth year data.
 */
export function getPlayerAge(name, seasonYear = 2025) {
  // Check runtime cache first
  if (_ageCache[name]) return seasonYear - _ageCache[name] + 1;
  // Check static data
  if (PLAYER_BIRTH_YEARS[name]) return seasonYear - PLAYER_BIRTH_YEARS[name] + 1;
  // Unknown — estimate from salary if available, otherwise default
  return null;
}

/**
 * Estimate age from salary tier when no birth data available.
 * High salary + no data = likely established (27-30)
 * Low salary + no data = likely young (22-24)
 */
export function estimateAgeFromSalary(salary, seasonYear = 2025) {
  const salM = (salary || 0) / 1e6;
  if (salM > 35) return 28;
  if (salM > 25) return 27;
  if (salM > 15) return 26;
  if (salM > 8) return 25;
  if (salM > 3) return 24;
  return 23;
}

/**
 * Get player age with all fallbacks.
 * Priority: API cache > static data > salary estimate > default 25
 */
export function getPlayerAgeSafe(name, salary, seasonYear = 2025) {
  const age = getPlayerAge(name, seasonYear);
  if (age !== null) return age;
  if (salary) return estimateAgeFromSalary(salary, seasonYear);
  return 25; // safe default for unknowns
}

/**
 * Fetch ages from balldontlie API and cache them.
 * Call once on app load. Non-blocking — falls back to static data.
 */
export async function fetchAndCacheAges() {
  if (_cacheReady) return;
  try {
    // Fetch active players in batches (API returns 100 per page)
    for (let page = 1; page <= 6; page++) {
      const res = await fetch(`https://api.balldontlie.io/v1/players/active?per_page=100&page=${page}`, {
        headers: { 'Authorization': '4db4a3c1-7588-44d4-9e89-38e67eb0e1f8' }
      });
      if (!res.ok) break;
      const data = await res.json();
      if (!data.data || data.data.length === 0) break;
      for (const p of data.data) {
        const name = `${p.first_name} ${p.last_name}`;
        if (p.birth_date) {
          _ageCache[name] = new Date(p.birth_date).getFullYear();
        }
      }
    }
    _cacheReady = true;
  } catch (e) {
    // API unavailable — static data will be used
    console.log('Age fetch from API unavailable, using static data');
  }
}

/**
 * Manually set age cache (e.g., from saved data).
 */
export function loadAgeCache(cache) {
  if (cache && typeof cache === 'object') {
    _ageCache = { ...cache };
    _cacheReady = true;
  }
}

/**
 * Get the full age cache for saving.
 */
export function getAgeCache() {
  return { ..._ageCache };
}

/**
 * Register a draft class of prospects with assumed birth years.
 * For future draft classes where we don't have real ages, default to 19-20.
 */
export function registerDraftClass(prospects, defaultBirthYear) {
  if (!prospects || !Array.isArray(prospects)) return;
  for (const p of prospects) {
    const name = p.name || p;
    if (name && !_ageCache[name] && !PLAYER_BIRTH_YEARS[name]) {
      _ageCache[name] = defaultBirthYear || (new Date().getFullYear() - 19);
    }
  }
}

export default { getPlayerAge, getPlayerAgeSafe, estimateAgeFromSalary, fetchAndCacheAges, loadAgeCache, getAgeCache, registerDraftClass, PLAYER_BIRTH_YEARS };
